import axios from 'axios';
import { clearLegacyAuthTokens } from '../utils/legacyAuthCleanup';
import { installSessionExpiryInterceptor } from '../utils/sessionExpiry';

/**
 * Public API is always called as `${origin}/api/...`.
 * REACT_APP_API_URL must be the origin only (e.g. https://api.example.com).
 * If someone sets https://host.com/api by mistake, strip the trailing /api so
 * we never request https://host.com/api/api/... (404 "Route not found").
 */
function normalizeApiOrigin(raw) {
  if (!raw) return '';
  let s = String(raw).trim();
  s = s.replace(/\/+$/, '');
  s = s.replace(/\/api$/i, '');
  s = s.replace(/\/+$/, '');
  return s;
}

const trimmed = normalizeApiOrigin(process.env.REACT_APP_API_URL || '');
const API_URL = trimmed || 'http://localhost:5001';
const baseURL = `${API_URL}/api`;

const analyticsWriteKey = process.env.REACT_APP_ANALYTICS_WRITE_KEY?.trim() || '';

if (!trimmed && process.env.NODE_ENV === 'production') {
  // eslint-disable-next-line no-console
  console.error(
    '[MyCarSlot] REACT_APP_API_URL is not set. This build calls http://localhost:5001 for the API, so the live site will show no cars. ' +
      'Add REACT_APP_API_URL=https://your-api-host.example.com (hostname only — do not include /api; the client appends /api itself) in your frontend env, rebuild, and redeploy.'
  );
}

clearLegacyAuthTokens();

export const api = axios.create({
  baseURL,
  withCredentials: true,
});

api.interceptors.request.use(
  (config) => {
    const url = config.url || '';
    const isAnalyticsWrite =
      config.method !== 'get' &&
      (url.startsWith('/analytics/') || url.includes('/analytics/'));
    if (isAnalyticsWrite && analyticsWriteKey) {
      config.headers = config.headers || {};
      config.headers['X-Analytics-Key'] = analyticsWriteKey;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

installSessionExpiryInterceptor(api);
installSessionExpiryInterceptor(axios);

/** Superadmin HTTP client — always sends session cookies cross-origin. */
export const superadminApi = api;

export { API_URL };
export default api;
